import React from 'react';

export default class Form extends React.Component {
  constructor(props) {
    super(props)
    const fields = props.fields || {}
    this.state = {
      fields: {...fields},
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.props.onSubmit) {
      this.props.onSubmit(this.state.fields);
    }
  }

  handleFieldChange(field) {
    this.setSate({[field.name]: field.value});
  }

  render() {
    const props = this.props
    const formProps = {
      id: props.id,
      className: props.horizontal ? form-horizontal : null,
      onSubmit: this.handleSubmit,
    };
    return (<form {...formProps}>{props.children}</form>)
  }

}

/*
export default function Form(props) {
  const onSubmit = function (e) {
    e.preventDefault();
    const data = new FormData(e.target);
    console.log(data);
    if (props.onSubmit) props.onSubmit(e.target.value);
    else console.log('submit', e.target.value);
  };
  const formProps = {
    id: props.id,
    className: props.horizontal ? form-horizontal : null,
    onSubmit,
  };
  return (<form {...formProps}>{props.children}</form>);
};
*/



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/Form.jsx